<template>
	<div>
		<v-row>
			<v-col md="12">
				<v-card elevation="5" class="pa-4">
					<div>
						<v-btn
							fab
							x-small
							color="red"
							text
							@click="updateValue(true)"
						>
							<v-icon> mdi-axis-z-rotate-clockwise </v-icon>
						</v-btn>
					</div>
					<div
						:style="
							$vuetify.breakpoint.smAndDown
								? 'height: 260px; align-items: center'
								: 'height: 420px; align-items: center'
						"
						class="d-flex justify-center"
						align="center"
					>
						<h1
							v-if="tenantName"
							:class="
								$vuetify.breakpoint.mdAndDown
									? 'overline'
									: 'display-3 font-weight-normal'
							"
							style="transform: rotate(-45deg);"
						>
							{{ capitalize(tenantName) }}
						</h1>
						<img
							v-else
							@error="imgError(tenant.name)"
							:src="getLogo(tenant.name)"
							:width="
								$vuetify.breakpoint.mdAndDown ? '30%' : '50%'
							"
						/>
					</div>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>


<script>
export default {
	name: 'TenantFrontCard',
	props: {
		// value: 'value',
		tenant: Object,
	},
	data: () => ({
		tenantName: '',
	}),
	methods: {
		updateValue: function (value) {
			this.$emit('input', value);
		},
		getLogo(name) {
			return `https://storage.googleapis.com/gespym-images/tenants-logos/${name}.png`;
		},
		imgError(name) {
			this.tenantName = name;
		},
		capitalize(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},
	},
	computed: {},
};
</script>


<style>
</style>